/* Accept Invitation — staf membuat akun dari link undangan (Multi Admin v1). */
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AcceptInvitation() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setError("Link undangan tidak valid."); return; }
    api.get("/auth/invitations/verify", { params: { token } })
      .then((r) => setInfo(r.data))
      .catch((e) => setError(formatApiError(e) || "Undangan tidak valid atau telah kedaluwarsa."));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password minimal 8 karakter."); return; }
    setSaving(true);
    try {
      await api.post("/auth/invitations/accept", { token, name, password });
      toast.success("Akun berhasil dibuat! Silakan login.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(formatApiError(err) || "Gagal menerima undangan.");
    }
    setSaving(false);
  };

  return (
    <div className="min-h-screen grid place-items-center p-4" style={{ backgroundColor: "var(--brand-background, #FAF9F6)" }}>
      <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#E5E5E5] w-full max-w-md" data-testid="accept-invitation-page">
        <div className="flex justify-center mb-5"><Logo variant="compact" size="md" to={null} /></div>
        {error ? (
          <div className="text-center" data-testid="invitation-error">
            <h2 className="font-display text-xl font-black mb-2">Undangan Tidak Valid</h2>
            <p className="text-sm text-[#5C5C5C]">{error}</p>
          </div>
        ) : !info ? (
          <div className="text-center text-sm text-[#5C5C5C] animate-pulse">Memeriksa undangan…</div>
        ) : (
          <>
            <h2 className="font-display text-xl font-black mb-1 text-center">Bergabung ke Tim</h2>
            <p className="text-sm text-[#5C5C5C] text-center mb-1">
              Anda diundang ke <b>{info.tenant_name}</b> sebagai <b>{info.role}</b>.
            </p>
            <p className="text-[11px] text-[#5C5C5C] text-center mb-5">{info.role_description}</p>
            <form onSubmit={submit} className="space-y-3">
              <div><Label>Email</Label><Input value={info.email} readOnly disabled className="rounded-xl bg-[#FAF9F6]" data-testid="accept-email-input" /></div>
              <div><Label>Nama Lengkap</Label><Input required value={name} onChange={(e) => setName(e.target.value)} className="rounded-xl" data-testid="accept-name-input" /></div>
              <div><Label>Password</Label><Input required type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Minimal 8 karakter" className="rounded-xl" data-testid="accept-password-input" /></div>
              <Button type="submit" disabled={saving} className="w-full system-btn-primary rounded-xl font-bold" data-testid="accept-submit-btn">
                {saving ? "Membuat akun…" : "Buat Akun & Bergabung"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
